// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("./fonts/Urbanist-VariableFont_wght.ttf", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@font-face {
  font-family: 'Urbanist';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___}); }

html,
body,
#root {
  height: 100%; }

#root {
  overflow: hidden; }

.main-row {
  overflow: auto;
  height: 100vh !important; }

.App {
  text-align: center; }

.App-header {
  background-color: #282c34;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  font-size: calc(10px + 2vmin);
  color: white; }

.App-link {
  color: #61dafb; }

.reportTable {
  font-size: 18px !important; }

.reportTable .report-table__header {
  vertical-align: middle;
  position: sticky;
  top: 0;
  z-index: 1;
  background-color: #0b1736; }

.sidebar-menu {
  overflow: auto; }

.app-other .report-screen {
  display: none; }

.app-other .views {
  display: none; }

.app-other #report-btns {
  display: none; }

.app-other .fullscreen {
  display: none; }

.app-other .reports-container {
  max-width: 100vw;
  overflow: auto;
  margin: 1rem; }
  .app-other .reports-container .fullscreen-enabled {
    overflow: auto;
    background-color: #050e24; }

.data-container {
  padding-top: 63px !important; }

.report-content {
  margin-top: 50px;
  width: 100%;
  padding-left: 100px;
  padding-right: 100px; }
  .report-content .report-content__title {
    color: #fff; }

.table-row__selected {
  background-color: #021d3e; }

.report__container-background {
  background-color: #0b1736;
  border-radius: 12px;
  box-shadow: 0px 0px 20px #000; }

.source-footer-label {
  text-align: right;
  padding-top: 1rem; }

.container--expand-container {
  position: absolute;
  top: 52px !important;
  left: 85px;
  height: 93vh !important;
  width: calc(100% - 100px);
  z-index: 100; }
  .container--expand-container .row.chart-container {
    height: 80vh !important; }

#root .app-alert-main {
  position: absolute;
  z-index: 111;
  top: 300px;
  width: 400px;
  left: 100px;
  color: white;
  background-color: #18244c;
  border-color: #0b1736;
  box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.1); }
  #root .app-alert-main img {
    width: 180px;
    margin-left: 87px;
    margin-top: 12px;
    margin-bottom: 8px; }
  #root .app-alert-main p {
    padding-left: 25px; }
  #root .app-alert-main .alert-heading {
    padding-left: 25px;
    margin-top: 24px;
    margin-bottom: 14px; }

#root .app-alert-help {
  position: absolute;
  z-index: 555;
  top: 120px;
  width: 750px;
  left: 100px;
  color: white;
  background-color: #18244c;
  border-color: #0b1736;
  box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.1); }
  #root .app-alert-help .app-alert-main-img {
    width: 180px;
    margin-left: 41%;
    margin-top: 20px; }
  #root .app-alert-help p {
    padding-left: 25px; }
  #root .app-alert-help .alert-heading {
    margin-bottom: 20px; }

.mapboxgl-ctrl-top-left {
  transform: translateY(200px); }

.app-tooltip {
  background-color: #050e25; }

.mapboxgl-popup-content {
  background-color: #18244c;
  color: white; }

.marker-container {
  background-color: #0c1836;
  color: white; }

#reportsContainer {
  height: 100vh; }

.nv-popoverContent {
  z-index: 544; }

.nv-dropdownContent {
  z-index: 545; }
`, "",{"version":3,"sources":["webpack://./src/theme/_variables.scss","webpack://./src/App.scss"],"names":[],"mappings":"AAqBA;EACE,uBAAuB;EACvB,4CAAmD,EAAA;;ACrBrD;;;EAGE,YAAY,EAAA;;AAGd;EACE,gBAAgB,EAAA;;AAGlB;EACE,cAAc;EACd,wBAAwB,EAAA;;AAG1B;EACE,kBAAkB,EAAA;;AAGpB;EACE,yBAAyB;EACzB,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,6BAA6B;EAC7B,YAAY,EAAA;;AAGd;EACE,cAAc,EAAA;;AAGhB;EACE,0BAA0B,EAAA;;AAG5B;EACE,sBAAsB;EACtB,gBAAgB;EAChB,MAAM;EACN,UAAU;EACV,yBD/B4B,EAAA;;ACkC9B;EACE,cAAc,EAAA;;AAGhB;EAEI,aAAa,EAAA;;AAFjB;EAMI,aAAa,EAAA;;AANjB;EAUI,aAAa,EAAA;;AAVjB;EAcI,aAAa,EAAA;;AAdjB;EAiBI,gBAAgB;EAChB,cAAc;EACd,YAAY,EAAA;EAnBhB;IAqBM,cAAc;IACd,yBAAyB,EAAA;;AAK/B;EACE,4BAA4B,EAAA;;AAG9B;EACE,gBAAgB;EAChB,WAAW;EACX,mBAAmB;EACnB,oBAAoB,EAAA;EAJtB;IAOI,WAAW,EAAA;;AAIf;EACE,yBAAyB,EAAA;;AAG3B;EACE,yBDhG8B;ECiG9B,mBAAmB;EACnB,6BAA6B,EAAA;;AAG/B;EACE,iBAAiB;EACjB,iBAAiB,EAAA;;AAGnB;EACE,kBAAkB;EAClB,oBAAoB;EACpB,UAAU;EACV,uBAAuB;EACvB,yBAAyB;EACzB,YAAY,EAAA;EANd;IASI,uBAAuB,EAAA;;AAI3B;EAEI,kBAAkB;EAClB,YAAY;EACZ,UAAU;EACV,YAAY;EACZ,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,qBAAqB;EACrB,2CAA2C,EAAA;EAV/C;IAaM,YAAY;IACZ,iBAAiB;IACjB,gBAAgB;IAChB,kBAAkB,EAAA;EAhBxB;IAoBM,kBAAkB,EAAA;EApBxB;IAwBM,kBAAkB;IAClB,gBAAgB;IAChB,mBAAmB,EAAA;;AA1BzB;EA+BI,kBAAkB;EAClB,YAAY;EACZ,UAAU;EACV,YAAY;EACZ,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,qBAAqB;EACrB,2CAA2C,EAAA;EAvC/C;IA0CM,YAAY;IACZ,gBAAgB;IAChB,gBAAgB,EAAA;EA5CtB;IAgDM,kBAAkB,EAAA;EAhDxB;IAoDM,mBAAmB,EAAA;;AAMzB;EACE,4BAA4B,EAAA;;AAI9B;EACI,yBAAyB,EAAA;;AAG7B;EACE,yBAAyB;EACzB,YAAY,EAAA;;AAGd;EACE,yBAAyB;EACzB,YAAY,EAAA;;AAGd;EACE,aAAa,EAAA;;AAGf;EACE,YAAY,EAAA;;AAGd;EACE,YAAY,EAAA","sourcesContent":["$primaryFontColor: #fff;\n$secundaryFontColor: #4fc2d9;\n$thirdFontColor: #0b1736;\n$topMenuBackgroundColor: #0b1736;\n$sideBackgroundColor: #002044;\n$sideSubMenuBackgroundColor: #0b1736;\n$fontFamily: 'Urbanist';\n$leftMenuWidth: 5rem;\n$rightMenuWidth: 400px;\n$navBrandImageSize: 150px;\n$darkAndLightModeBackgroundColor: #12234f;\n$dropdownFiltersBackgroundColor: #060e21;\n$inputFocusBackgroundColor: #060e21;\n$containerScreenBackgroundColor: #050e25;\n$tableBackgroundColor: #0b1736;\n$secondarySubtitleColor: #838487;\n\n//FORMS\n$inputBackgroundColor: #021d3e;\n$btnPrimary: #257ee0;\n\n@font-face {\n  font-family: 'Urbanist';\n  src: url('../fonts/Urbanist-VariableFont_wght.ttf');\n}\n","@import \"./theme/_variables.scss\";\n\nhtml,\nbody,\n#root {\n  height: 100%;\n}\n\n#root {\n  overflow: hidden;\n}\n\n.main-row {\n  overflow: auto;\n  height: 100vh !important;\n}\n\n.App {\n  text-align: center;\n}\n\n.App-header {\n  background-color: #282c34;\n  min-height: 100vh;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  font-size: calc(10px + 2vmin);\n  color: white;\n}\n\n.App-link {\n  color: #61dafb;\n}\n\n.reportTable {\n  font-size: 18px !important;\n}\n\n.reportTable .report-table__header {\n  vertical-align: middle;\n  position: sticky;\n  top: 0;\n  z-index: 1;\n  background-color: $tableBackgroundColor;\n}\n\n.sidebar-menu {\n  overflow: auto;\n}\n\n.app-other {\n  .report-screen {\n    display: none;\n  }\n\n  .views {\n    display: none;\n  }\n\n  #report-btns {\n    display: none;\n  }\n\n  .fullscreen {\n    display: none;\n  }\n  .reports-container {\n    max-width: 100vw;\n    overflow: auto;\n    margin: 1rem;\n    .fullscreen-enabled {\n      overflow: auto;\n      background-color: #050e24;\n    }\n  }\n}\n\n.data-container {\n  padding-top: 63px !important;\n}\n\n.report-content {\n  margin-top: 50px;\n  width: 100%;\n  padding-left: 100px;\n  padding-right: 100px;\n\n  .report-content__title {\n    color: #fff;\n  }\n}\n\n.table-row__selected {\n  background-color: #021d3e;\n}\n\n.report__container-background {\n  background-color: $topMenuBackgroundColor;\n  border-radius: 12px;\n  box-shadow: 0px 0px 20px #000;\n}\n\n.source-footer-label {\n  text-align: right;\n  padding-top: 1rem;\n}\n\n.container--expand-container {\n  position: absolute;\n  top: 52px !important;\n  left: 85px;\n  height: 93vh !important;\n  width: calc(100% - 100px);\n  z-index: 100;\n\n  .row.chart-container {\n    height: 80vh !important;\n  }\n}\n\n#root {\n  .app-alert-main {\n    position: absolute;\n    z-index: 111;\n    top: 300px;\n    width: 400px;\n    left: 100px;\n    color: white;\n    background-color: #18244c;\n    border-color: #0b1736;\n    box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.1);\n\n    img {\n      width: 180px;\n      margin-left: 87px;\n      margin-top: 12px;\n      margin-bottom: 8px;\n    }\n\n    p {\n      padding-left: 25px;\n    }\n\n    .alert-heading {\n      padding-left: 25px;\n      margin-top: 24px;\n      margin-bottom: 14px;\n    }\n  }\n\n  .app-alert-help {\n    position: absolute;\n    z-index: 555;\n    top: 120px;\n    width: 750px;\n    left: 100px;\n    color: white;\n    background-color: #18244c;\n    border-color: #0b1736;\n    box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.1);\n\n    .app-alert-main-img {\n      width: 180px;\n      margin-left: 41%;\n      margin-top: 20px;\n    }\n\n    p {\n      padding-left: 25px;\n    }\n\n    .alert-heading {\n      margin-bottom: 20px;\n    }\n  }\n\n}\n\n.mapboxgl-ctrl-top-left {\n  transform: translateY(200px);\n}\n\n\n.app-tooltip {\n    background-color: #050e25;\n}\n\n.mapboxgl-popup-content {\n  background-color: #18244c;\n  color: white;\n}\n\n.marker-container {\n  background-color: #0c1836;\n  color: white;\n}\n\n#reportsContainer {\n  height: 100vh;\n}\n\n.nv-popoverContent {\n  z-index: 544;\n}\n    \n.nv-dropdownContent {\n  z-index: 545;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
